import classNames from 'classnames';
import { FunctionComponent } from 'react';
import { ExclamationCircleIcon } from '@heroicons/react/solid';
import { UseFormRegisterReturn } from 'react-hook-form';

interface Props {
  name?: string;
  id: string;
  type?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  className?: string;
  onChange?: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  hasError?: boolean;
  register?: UseFormRegisterReturn;
  darkSupport?: boolean;
}

const FormInput: FunctionComponent<Props> = ({
  name,
  id,
  type = 'text',
  label = '',
  placeholder,
  required,
  className,
  onChange,
  hasError = false,
  register,
  darkSupport = true,
}) => {
  const options = { name, onChange, required };

  return (
    <span>
      {label && (
      <label
        className={classNames(
          {
            'text-white-3': darkSupport,
            'text-gray-900': !darkSupport,
          },
          'block text-p3 lg:text-p2 font-medium mb-1.5 overflow-hidden text-ellipsis whitespace-nowrap',
        )}
        htmlFor={id}
      >
        {label}
      </label>
      )}
      <div className="relative w-full">
        <input
          type={type}
          id={id}
          placeholder={placeholder}
          required={required}
          {...(register ?? options)}
          className={classNames(
            className,
            { 'border-white': darkSupport },
            { 'border-black': !darkSupport },
            'rounded-md h-[2.875rem] block w-full shadow-sm p-3 border',
            'bg-white-2 text-p3',
            {
              'text-gray-1 placeholder-gray-7 focus:ring-gray-800 focus:border-gray-500': !hasError,
              'border-red-300 text-red-500 placeholder-red-500': hasError,
              'focus:ring-red-500 focus:border-red-500 focus:outline-none': hasError,
            },
          )}
        />
        {hasError && (
        <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
          <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />
        </div>
        )}
      </div>
    </span>
  );
};

export default FormInput;
